"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _uxcore = require("@ux/uxcore2");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _DomainSearchResultComponent = _interopRequireDefault(require("./DomainSearchResultComponent"));
var _storeProvider = require("./../util/storeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class DomainResultsComponent extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };
  }
  disclaimer() {
    const {
      disclaimerLinkText = '',
      disclaimerText = '',
      disclaimerTitle = ''
    } = this.props.content;
    if (disclaimerLinkText === '' || disclaimerText === '') return null;
    const modal = this.state.modal ? /*#__PURE__*/React.createElement(_uxcore.Modal, {
      title: disclaimerTitle,
      onClose: () => {
        this.setState({
          modal: false
        });
      }
    }, /*#__PURE__*/React.createElement("div", null, this.context.store.parseHtml(disclaimerText))) : null;
    return /*#__PURE__*/React.createElement(_react.Fragment, null, /*#__PURE__*/React.createElement(_uxcore.Button, {
      className: "disclaimer-link",
      "aria-haspopup": "true",
      "data-eid": this.context.store.getEid('domain_disclaimer', 'button', 'click'),
      design: "inline",
      onClick: () => {
        this.setState({
          modal: true
        });
      },
      text: disclaimerLinkText
    }), modal);
  }
  render() {
    const {
      context: {
        store
      },
      props
    } = this;
    const {
      content: groupContent = {},
      domainSearch = {}
    } = props;
    const {
      domainUnavailableSpinsTitle = '',
      domainUnavailableForOfferTitle = '',
      domainAvailableTitle = '',
      domainAvailableSpinsTitle = ''
    } = groupContent;
    const {
      exactDomain = {},
      domains = [],
      match = false
    } = domainSearch;
    if (domains.length === 0) return null;
    const showIcannFeeDisclaimer = domains.filter(x => x.showIcannFee).length > 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "mt-3"
    }, !match && exactDomain && exactDomain.name && /*#__PURE__*/React.createElement("h3", null, " ", store.parseHtml(domainUnavailableForOfferTitle)), match && exactDomain && exactDomain.name && /*#__PURE__*/React.createElement(_react.Fragment, null, /*#__PURE__*/React.createElement("h3", null, store.parseHtml(domainAvailableTitle)), /*#__PURE__*/React.createElement(_DomainSearchResultComponent.default, _extends({}, this.props, {
      resultType: "exact",
      groupContent: groupContent,
      domainProductInfo: exactDomain
    }))), match && /*#__PURE__*/React.createElement("div", {
      className: "h4 mt-4"
    }, domainAvailableSpinsTitle), !match && /*#__PURE__*/React.createElement("div", {
      className: "h4 mt-4"
    }, domainUnavailableSpinsTitle), domains.map((domain, i) => {
      return /*#__PURE__*/React.createElement("div", {
        key: domain.name
      }, /*#__PURE__*/React.createElement(_DomainSearchResultComponent.default, _extends({}, this.props, {
        resultType: `spin-${i}`,
        groupContent: groupContent,
        domainProductInfo: domain
      })));
    }), showIcannFeeDisclaimer && this.disclaimer());
  }
}
DomainResultsComponent.propTypes = {
  disabled: _propTypes.default.bool,
  domainSearch: _propTypes.default.object,
  content: _propTypes.default.object
};
var _default = exports.default = (0, _storeProvider.provideContext)(DomainResultsComponent);